import React, { useRef, useCallback } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const PREDEFINED_COLORS = ["#0ca854", "#000000", "#ffffff", "#f0fff8", "#eeeeee"];

const CustomToolbar = ({ toolbarId, onPredefinedColorSelect }) => (
  <div id={toolbarId}>
    <select className="ql-header" defaultValue="">
      <option value="1"></option>
      <option value="2"></option>
      <option value=""></option>
    </select>
    <button className="ql-bold"></button>
    <button className="ql-italic"></button>
    <button className="ql-underline"></button>
    <button className="ql-strike"></button>
    <select className="ql-color" />
    <select className="ql-background" />
    <select className="ql-align" />
    <button className="ql-link"></button>
    <button className="ql-list" value="bullet" />
    <button className="ql-list" value="ordered" />
    <button className="ql-indent" value="-1" title="Decrease Indent" />
    <button className="ql-indent" value="+1" title="Increase Indent" />
    <button className="ql-image"></button>
    <button className="ql-clean"></button>

    {/* Custom color buttons */}
    <div style={{ display: "inline-block", marginLeft: "10px" }}>
      {PREDEFINED_COLORS.map((color) => (
        <button
          key={color}
          type="button"
          onClick={() => onPredefinedColorSelect(color)}
          style={{
            backgroundColor: color,
            border: "1px solid #ccc",
            marginRight: "5px",
            width: "20px",
            height: "20px",
            cursor: "pointer",
          }}
          title={`Apply color ${color}`}
        />
      ))}
    </div>
  </div>
);

const QuillWithPredefinedColors = ({ value, onChange, id }) => {
  const quillRef = useRef(null);
  const toolbarId = `toolbar-${id}`;

  const handlePredefinedColorSelect = useCallback((color) => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;

    const range = editor.getSelection();
    if (range) {
      editor.formatText(range.index, range.length, "color", color);
    } else {
      // Set for future input
      editor.format("color", color);
    }
  }, []);

  const modules = {
    toolbar: {
      container: `#${toolbarId}`,
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "clean",
  ];

  return (
    <>
      <CustomToolbar toolbarId={toolbarId} onPredefinedColorSelect={handlePredefinedColorSelect} />
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        theme="snow"
        modules={modules}
        formats={formats}
        style={{ height: "200px", marginBottom: "50px" }}
      />
    </>
  );
};

export default QuillWithPredefinedColors;
